import { render, staticRenderFns } from "./EditorScaleControls.vue?vue&type=template&id=2a8a0a5d&scoped=true&"
import script from "./EditorScaleControls.vue?vue&type=script&lang=ts&"
export * from "./EditorScaleControls.vue?vue&type=script&lang=ts&"
import style0 from "./EditorScaleControls.vue?vue&type=style&index=0&id=2a8a0a5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8a0a5d",
  null
  
)

export default component.exports